import * as actionTypes from 'constants/ActionTypes';

const cargoNames = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGOES_BY_TYPE_NAME.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };

    case actionTypes.GET_CARGOES_BY_TYPE_NAME.SUCCESS: {
        const data = action.data.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
        }));
        return {
            ...state,
            items: data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_CARGOES_BY_TYPE_NAME.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
        
    default:
        return state;
    }
};

export default cargoNames;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/names.js